<template>
  <div class="calendar-wrapper">
    <CalendarMonth
      v-if="!selectedDay"
      :year="currentYear"
      :month="currentMonth"
      :monthNames="monthNames"
      :highlightDays="appointmentDays"
      @day-selected="selectedDay = $event"
      @prev-month="prevMonth"
      @next-month="nextMonth"
    />

    <CalendarDayView
      v-if="selectedDay"
      :day="selectedDay"
      :month="currentMonth"
      :year="currentYear"
      @back="selectedDay = null"
      @prev-day="goPrevDay"
      @next-day="goNextDay"
    />
 
  </div>
</template>

<script>
import axios from 'axios'
import CalendarMonth from './CalendarMonth.vue'
import CalendarDayView from './CalendarDayView.vue' 

export default {
  name: 'UserCalendar',
  components: { CalendarMonth, CalendarDayView },
  data() {
    const today = new Date()
    return {
      currentYear: today.getFullYear(),
      currentMonth: today.getMonth(),
      selectedDay: null,
      appointmentDays: []
    }
  },
  computed: {
    monthNames() {
      return Array.from({ length: 12 }, (_, i) => this.$t(`randevu.months.${i}`))
    }
  },
  mounted() {
    this.fetchAppointments()
  },
  methods: {
    async fetchAppointments() {
      try {
        const { data } = await axios.get('/promo/user/appointments/by-month', {
          params: {
            year: this.currentYear,
            month: this.currentMonth + 1
          }
        })
        this.appointmentDays = data
      } catch (e) {
        this.appointmentDays = []
      }
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11
        this.currentYear -= 1
      } else {
        this.currentMonth -= 1
      }
      this.fetchAppointments()
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0
        this.currentYear += 1
      } else {
        this.currentMonth += 1
      }
      this.fetchAppointments()
    },
    goPrevDay({ day, month, year }) {
      this.selectedDay = day
      this.currentMonth = month
      this.currentYear = year
    },
    goNextDay({ day, month, year }) {
      this.selectedDay = day
      this.currentMonth = month
      this.currentYear = year
    }
  }
}
</script>

<style scoped>
.calendar-wrapper {
  max-width: 100%;
}

@media (min-width: 768px) {
  .calendar-wrapper {
    max-width: 1080px;
    margin: 0 auto;
  }
}
</style>
